// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__FweHs","Aside":"Layout_Aside__3GZFi","Main":"Layout_Main__SUpDD","Footer":"Layout_Footer__NHAF4","padd_solutions":"Layout_padd_solutions__tPi4N"};